fetch('https://stockist.co/api/v1/u24586/locations/all')
.then((response) => response.json())
.then((locations) => {
  console.log("STOCKIST LOCATIONS:", locations);
  const sortedLocations = sortLocationsByPostalCode(locations);
  console.log(sortedLocations.map(item => item.postal_code));
  let locationsByCountry = sortLocationsByCountry(locations);
  createCountries(locationsByCountry);

});

function getCountries(locations) {
  // let countries = locations.map((location) => location.country);
  let countries = [];
  locations.forEach(function(location) {
    location.country && countries.push(location.country);
  });
  countries = [...new Set(countries)];
  console.log('COUNTRIES', countries);
  return countries;
}


function sortLocationsByCountry(locations) {
  let uniqueCountries = getCountries(locations);
  const referenceArray = ['France', 'Drom/Com', 'Maroc', 'Belgique'];
  const sortedCountries = sortByReference(uniqueCountries, referenceArray);
  console.log(sortedCountries);
  
  const sortedLocations = sortedCountries.map(function(country) {
    let singleCountryLocations = locations.filter(function(location) {
      return location.country === country;
    });
    return {
      country: country,
      locations: singleCountryLocations
    }
  });
  console.log(sortedLocations);

  return sortedLocations;
}

function sortLocationsByPostalCode(locations) {
  // Sort the array in place based on the numerical value of postal_code.
  return locations.sort((a, b) => {
    // Convert postal_code strings to numbers for proper numerical comparison.
    const postalA = Number(a.postal_code.substring(0, 2));
    const postalB = Number(b.postal_code.substring(0, 2));
    return postalA - postalB;
  });
}

function createCountries(locationsByCountry) {
  let countriesContainer = document.getElementById('stores-list');
  const countryTemplate = document.getElementById('store-list-country-template');
  const columnTemplate = document.getElementById('store-list-column-template');
  const entryTemplate = document.getElementById('store-list-entry-template');
  const MAX_COL_ENTRIES = 35;

  locationsByCountry.forEach(function(entry) {
    const countryClone = countryTemplate.content.cloneNode(true);
    if(entry.country === 'France') {
      countryClone.querySelector('.stores-list__country-title').textContent = 'France Métropolitaine';
    } else if(entry.country === 'Drom/Com') {
      countryClone.querySelector('.stores-list__country-title').textContent = 'DOM-TOM';
    } else {
      countryClone.querySelector('.stores-list__country-title').textContent = entry.country;
    }
    let columnCount = Math.ceil(entry.locations.length / MAX_COL_ENTRIES);
    let entryColumns = [];
    for(i = 0; i < columnCount; i++) {
      entryColumns.push(columnTemplate.content.cloneNode(true));
    }
    for(i = 0; i < entry.locations.length; i++) {
      let currentColumn = Math.floor(i / MAX_COL_ENTRIES);
      let entryClone = entryTemplate.content.cloneNode(true);
      let entryLink = entryClone.querySelector('a');
      let currentLocation = entry.locations[i];

      if(currentLocation) {
        entryLink.href = currentLocation.website;
        entryLink.querySelector('.location-title').textContent = currentLocation.name.replace('FitnessBoutique', '');
        entryLink.title = currentLocation.name;
        entryLink.querySelector('.postal-code').textContent = currentLocation.postal_code.substring(0, 2);
        entryColumns[currentColumn].querySelector('.stores-list__entries').appendChild(entryLink);
      } else {
        debugger
      }
      

    }
    entryColumns.forEach(function(entryColumn) {
      countryClone.querySelector('.stores-list__columns').appendChild(entryColumn);
    });
    countriesContainer.appendChild(countryClone);
  });
}

function sortByReference(originalArray, referenceArray) {
  const orderMap = new Map(referenceArray.map((item, index) => [item, index]));

  return originalArray.slice().sort((x, y) => {
    const indexX = orderMap.has(x) ? orderMap.get(x) : Infinity;
    const indexY = orderMap.has(y) ? orderMap.get(y) : Infinity;

    if (indexX === indexY) {
      return x.localeCompare(y);
    }

    return indexX - indexY;
  });
}